import { Alert, Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLangPath } from "../../hooks/langAlias";
import { getBlogs } from "../../reduxToolkit/features/adminPanel/blog";
import { mergeBlogList } from "../../hooks/mergeBlogList";
import BlogCard from "../../screens/adminPanel/blog/components/BlogCard";
import LoadingBox from "../misc/Loading";
import { Fragment } from "react";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { colors, fonts, radii } from "../../theme/designTokens";

export default function BlogSection() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const lp = useLangPath();
  const [loadingMain, setLoadingMain] = useState(false);
  const [blogList, setBlogList] = useState([]);
  const [blogListEn, setBlogListEn] = useState([]);

  const [lang, setLang] = useState("en");
  const [langId, setLangId] = useState("");

  const [viewMode, setViewMode] = useState([]);
  // Store
  const { langs } = useSelector((state) => state.misc);
  const { blogs } = useSelector((state) => state.blog);
  const { activeLangFront } = useSelector((state) => state.miscFront);

  // Functions
  const getLangId = (langCode) => {
    let id = "";
    if (langs) {
      const L = langs.find((l) => l.langCode === langCode);
      if (L) id = L._id;
    }
    return id;
  };

  useEffect(() => {
    if (blogs && blogs.length > 0) {
      setLoadingMain(true);
      const enLangId = getLangId("en");
      setBlogList(mergeBlogList(blogs, langId, enLangId));
      const BEn = blogs.filter((b) => b.langId === enLangId);
      if (BEn) setBlogListEn(BEn);
      if (blogs) {
        setTimeout(() => {
          setLoadingMain(false);
        }, 1000);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blogs, langId]);

  // Set Language
  useEffect(() => {
    if (activeLangFront) {
      setLang(activeLangFront.langCode);
      setLangId(activeLangFront._id);
    }
  }, [activeLangFront]);

  useEffect(() => {
    if (blogs && blogs.length < 1) dispatch(getBlogs());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //! Translate
  // Store
  const { langArrFromClientSideFrontend } = useSelector(
    (state) => state.miscFront
  );
  const translateFront = (String) => {
    let translation = "";
    if (
      langArrFromClientSideFrontend &&
      langArrFromClientSideFrontend.length > 0
    ) {
      const T = langArrFromClientSideFrontend.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      }
    }
    return translation;
  };
  //! Translate

  return (
    <>
      {loadingMain ? (
        <LoadingBox w={"100%"} h={"200px"} />
      ) : (
        <Box sx={{ bgcolor: colors.paperTint, py: { xs: 4, md: 6 } }}>
          <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 2, sm: 3 } }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 2, mb: 3 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: radii.md,
                    bgcolor: colors.primaryLight,
                    color: colors.primary,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <ArticleOutlinedIcon fontSize="small" />
                </Box>
                <Box>
                  <Typography sx={{ fontFamily: fonts.display, fontWeight: 800, fontSize: "1.4rem", color: colors.ink }}>
                    {translateFront("Blogs")}
                  </Typography>
                  <Typography sx={{ fontSize: 13.5, color: colors.ink3 }}>
                    Guidance from our pharmacist team
                  </Typography>
                </Box>
              </Box>
              <Box
                onClick={() => navigate(lp("/blog"))}
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.75,
                  fontSize: 14,
                  fontWeight: 700,
                  color: colors.primary,
                  cursor: "pointer",
                  "&:hover": { color: colors.primaryDark },
                }}
              >
                {translateFront("View All")} <ArrowForwardIcon sx={{ fontSize: 16 }} />
              </Box>
            </Box>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  sm: "repeat(2, 1fr)",
                  md: "repeat(4, 1fr)",
                },
                gap: 3.5,
                alignItems: "stretch",
              }}
            >
              {blogList.length < 1 ? (
                <Alert severity="warning" sx={{ justifyContent: "center" }}>
                  {translateFront("No Blogs...")}
                </Alert>
              ) : (
                blogList.map((x, i) => (
                  <Fragment key={i}>
                    {i < 4 && (
                      <Box sx={viewMode.includes(x._id) ? { gridColumn: "1 / -1" } : undefined}>
                        <BlogCard
                          x={x}
                          blogListEn={blogListEn}
                          lang={lang}
                          frontEnd={true}
                          setViewMode={setViewMode}
                          viewMode={viewMode}
                          fromHome={true}
                        />
                      </Box>
                    )}
                  </Fragment>
                ))
              )}
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
}
